<section class="delete-all-users-modal-container">
  <h1>Delete Users</h1>
  <div class="body-section">
    <ng-container *ngTemplateOutlet="getTemplateForStep([Step1, Step2])"></ng-container>

    <ng-template #Step1>
      <p>
        User accounts within the selected group(s) at {{ schoolName }} will be
        permanently deleted. Please be aware that this action is irreversible.
      </p>
      <form class="checkbox-form"
        [formGroup]="form">
        <div>
          <div class="checkbox-input-label-group">
            <input id="teacherCheckbox"
              type="checkbox"
              formControlName="teachers"
              />
              <label for="teacherCheckbox">Teacher</label>
            </div>
            <ul>
              <li>Teachers will retain any other roles held.</li>
              <li>Licenses assigned to teachers will be revoked.</li>
            </ul>
          </div>
          <div class="checkbox-input-label-group">
            <input id="studentCheckbox"
              type="checkbox"
              formControlName="students"
              />
              <label for="studentCheckbox">Student</label>
            </div>
            <div class="checkbox-input-label-group">
              <input id="parentCheckbox"
                type="checkbox"
                formControlName="parents"
                />
                <label for="parentCheckbox">Parent</label>
              </div>
            </form>
          </ng-template>

          <ng-template #Step2>
            <p>All of the following users will be deleted at {{ schoolName }}:</p>
            <ul class="step-2-confirm-list">
              @if (form.controls.teachers.value) {
                <li>
                  <div>Teachers</div>
                  <ul>
                    <li>Teachers will retain any other roles held.</li>
                    <li>Licenses assigned to teachers will be revoked.</li>
                  </ul>
                </li>
              }
              @if (form.controls.students.value) {
                <li>Students</li>
              }
              @if (form.controls.parents.value) {
                <li>Parents</li>
              }
            </ul>
            <p>Do you want to proceed?</p>
          </ng-template>
        </div>
        <footer>
          <zbp-button-component
            (clickHandler)="onCancelButtonClick()"
            label="Cancel"
            theme="ghost"
            type="button"
          ></zbp-button-component>
          <zbp-button-component
            (clickHandler)="onDeleteButtonClick()"
            [label]="getDeleteButtonLabel()"
            theme="primary"
            type="button"
            [disabled]="!hasAnySelected()"
          ></zbp-button-component>
        </footer>
      </section>
